var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatureDocHub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 29 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.62184 2.519C4.86017 2.519 2.56684 4.75567 2.50184 7.514V25.339C2.44017 28.194 4.69017 30.5457 7.51684 30.609H20.9568C23.7384 30.494 25.9418 28.1823 25.9218 25.349V10.5657L18.1968 2.519H7.62184ZM7.46017 33.109C3.25684 33.014 -0.0898276 29.5173 0.00183905 25.3123V7.484C0.0985057 3.349 3.51351 0.019 7.61851 0.019H18.7301C19.0701 0.019 19.3951 0.157333 19.6318 0.402333L28.0734 9.19733C28.2968 9.429 28.4218 9.74067 28.4218 10.0623V25.339C28.4518 29.5207 25.1951 32.9373 21.0068 33.1073L7.46017 33.109Z",
    fill: "var(--fill-0, #4B4B4B)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1636 11.64H22.5719C19.5219 11.6317 17.0419 9.145 17.0419 6.09833V1.25C17.0419 0.56 17.6019 3.97364e-08 18.2919 3.97364e-08C18.9819 3.97364e-08 19.5419 0.56 19.5419 1.25V6.09833C19.5419 7.77167 20.9036 9.135 22.5753 9.14H27.1636C27.8536 9.14 28.4136 9.7 28.4136 10.39C28.4136 11.08 27.8536 11.64 27.1636 11.64Z",
    fill: "var(--fill-0, #4B4B4B)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9806 23.5135H8.98067C8.29067 23.5135 7.73067 22.9535 7.73067 22.2635C7.73067 21.5735 8.29067 21.0135 8.98067 21.0135H17.9806C18.6706 21.0135 19.2306 21.5735 19.2306 22.2635C19.2306 22.9535 18.6706 23.5135 17.9806 23.5135Z",
    fill: "var(--fill-0, #4B4B4B)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5724 17.2602H8.97917C8.28917 17.2602 7.72917 16.7002 7.72917 16.0102C7.72917 15.3202 8.28917 14.7602 8.97917 14.7602H14.5724C15.2624 14.7602 15.8224 15.3202 15.8224 16.0102C15.8224 16.7002 15.2624 17.2602 14.5724 17.2602Z",
    fill: "var(--fill-0, #4B4B4B)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureDocHub);
export default __webpack_public_path__ + "static/media/feature-doc-hub.20983d26270dd273b679fc5dee974590.svg";
export { ForwardRef as ReactComponent };